import React from 'react';
import { FiUser } from 'react-icons/fi';
import AdminModal from './AdminModal';

const AdminDetails = ({ isOpen, onClose, selectedAdmin }) => {
  return (
    <AdminModal
      isOpen={isOpen}
      onClose={onClose}
      title="Admin Details"
    >
      {selectedAdmin && (
        <div className="space-y-4">
          <div className="flex items-center justify-center mb-4">
            {selectedAdmin.image ? (
              <img 
                src={selectedAdmin.image} 
                alt={selectedAdmin.name} 
                className="h-20 w-20 rounded-full object-cover"
              />
            ) : (
              <div className="h-20 w-20 bg-gray-300 rounded-full flex items-center justify-center">
                <FiUser className="h-8 w-8 text-gray-600" />
              </div>
            )}
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">ID</label>
              <p className="text-gray-900">{selectedAdmin.id}</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Name</label>
              <p className="text-gray-900">{selectedAdmin.name}</p>
            </div>
            <div className="col-span-2">
              <label className="block text-sm font-medium text-gray-700">Email</label>
              <p className="text-gray-900">{selectedAdmin.email}</p>
            </div>
          </div>
        </div>
      )}
    </AdminModal>
  );
};

export default AdminDetails; 